import { HttpErrorResponse } from '@angular/common/http';

/**
 * Console-log a failed backend call without dumping the whole error object.
 * `HttpErrorResponse.error` can echo submitted values back (e.g. ASP.NET
 * ModelState responses), and this is a PHI surface — log only status and
 * message, never the response body.
 */
export function logHttpError(context: string, error: unknown): void {
  if (error instanceof HttpErrorResponse) {
    console.error(`${context} (HTTP ${error.status})`, error.message);
    return;
  }
  console.error(context, error instanceof Error ? error.message : error);
}
